<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      :add-text="handlePermission('mergeEqualGoodsAdd') ? '合并相同商品' : ''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>重复商品编码:</label>
            <lk-input class="item" v-model.trim="query.queryCode" clearable></lk-input>
          </div>
          <div class="queryItem">
            <label>合并至商品编码:</label>
            <lk-input class="item" v-model.trim="query.otherQueryCode" clearable></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch(false, pollingData)">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import toolsService from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

// 接口信息
export default {
  name: 'MergeEqualGoods',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      query: {
        queryCode: '', // 重复商品
        otherQueryCode: '', // 合并至商品
      },
      timer: null,
      statusMap: new Map([
        [1, '成功'],
        [2, '失败'],
        [3, '修改中...'],
      ]),
      showLog: false,
      columns: [
        {
          title: '重复商品',
          align: 'center',
          children: [
            { title: '商品编码', key: 'oldGoodsBaseSerialCode', minWidth: 116 },
            { title: '商品通用名', key: 'oldGoodsBaseApprovedName', minWidth: 116 },
            { title: '批准文号/注册证号', key: 'oldGoodsBaseApprovalCode', minWidth: 116 },
            { title: '规格', key: 'oldGoodsBaseSpec', minWidth: 116 },
          ],
        },
        {
          title: '合并至商品',
          align: 'center',
          children: [
            { title: '商品编码', key: 'newGoodsBaseSerialCode', minWidth: 116 },
            { title: '商品通用名', key: 'newGoodsBaseApprovedName', minWidth: 116 },
            { title: '批准文号/注册证号', key: 'newGoodsBaseApprovalCode', minWidth: 116 },
            { title: '规格', key: 'newGoodsBaseSpec', minWidth: 116 },
          ],
        },
        {
          title: '修改进度',
          key: 'status',
          minWidth: 116,
          render: (h, { row }) => h('span', {
            class: {
              error: row.status === 2,
            },
          }, this.statusMap.get(row.status)),
        },
        { title: '操作人', key: 'createUserName', minWidth: 116 },
        { title: '操作时间', key: 'createTimeStr', minWidth: 116 },
        {
          title: '涉及单据',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => (this.hasEditable ? h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.handleToDetail(row.detailId);
              },
            },
          }, '查看') : null),
        },
      ],
      tableData: [],
      logData: [],
    };
  },
  computed: {
    hasEditable() {
      return this.handlePermission('MergeEqualGoodsBizInfo');
    },
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData(loading) {
      return new Promise((resolve) => {
        this.params.page = this.page;
        this.params.size = this.size;
        this.$store.commit('setDisableLoading', loading);
        toolsService.getMergeEqualGoodsList(this.params).then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            const { count, list } = res.data.data;
            this.count = count;
            list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              result.createTimeStr = utils.formatTime(result.createTime); // 创建时间
              this.tableData.push(result);
            });
            resolve(this.tableData);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    addNew() {
      this.$router.push({ name: 'mergeEqualGoodsAdd' });
    },
    handleToDetail(id) {
      console.log(id);
      this.$router.push({
        name: 'MergeEqualGoodsBizInfo',
        params: {
          id,
        },
      });
    },
    pollingData() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData(true).then((data) => {
          this.tableData = data;

          // 没有数据或者都是完成状态
          if (data.every(item => item.status === 1)) {
            clearInterval(this.timer);
          }
        });
      }, 5000);
    },
  },
  created() {
    if (!this.hasEditable) {
      this.columns.pop();
    }
    this.handleSearch(true, this.pollingData);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
  .error {
    color: #ed4014;
  }
</style>
